export default __webpack_public_path__ + "static/media/re.f0a9bb18.jpg";